export default __webpack_public_path__ + "static/media/check_blue.d8ce5c00.svg";